<lex-doc-viewer-context-panel-template>
  <div context-body>
    <div style="overflow:auto; height: 87.5%;">
      <lex-doc-navigation-list [docListState]="docsContext" ></lex-doc-navigation-list>
    </div>
  </div>
</lex-doc-viewer-context-panel-template>
